/**
 * Plain-text helpers shared by the Central's WhatsApp modules (D636). Code-point arithmetic (the unit PostgreSQL's `char_length`
 * counts) and control-character handling by character code, so no regular expression has to name a control character.
 */
/** Number of Unicode code points (a surrogate pair counts once). */
export function cpLength(text) {
    let n = 0;
    for (const _ of text)
        n += 1;
    return n;
}
/** The first `max` code points of `text`. */
export function cpSlice(text, max) {
    let out = '';
    let n = 0;
    for (const ch of text) {
        if (n >= max)
            break;
        out += ch;
        n += 1;
    }
    return out;
}
const isControl = (c) => c <= 0x1f || (c >= 0x7f && c <= 0x9f);
/** True when `text` carries a C0/C1 control or DEL (a line feed counts unless `allowNewline`). */
export function hasControl(text, allowNewline = false) {
    for (let i = 0; i < text.length; i++) {
        const c = text.charCodeAt(i);
        if (isControl(c) && !(allowNewline && c === 0x0a))
            return true;
    }
    return false;
}
/** True when `text` holds a UTF-16 surrogate without its pair (not valid Unicode). */
export function hasLoneSurrogate(text) {
    for (let i = 0; i < text.length; i++) {
        const c = text.charCodeAt(i);
        if (c >= 0xd800 && c <= 0xdbff) {
            const next = text.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff)
                i += 1;
            else
                return true;
        }
        else if (c >= 0xdc00 && c <= 0xdfff)
            return true;
    }
    return false;
}
/** Remove every control character except the line feed, and every lone surrogate. */
export function stripUnsafe(text) {
    let out = '';
    for (let i = 0; i < text.length; i++) {
        const c = text.charCodeAt(i);
        if (c >= 0xd800 && c <= 0xdbff) {
            const next = text.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                out += text[i] + (text[i + 1] ?? '');
                i += 1;
            }
            continue;
        }
        if (c >= 0xdc00 && c <= 0xdfff)
            continue;
        if (isControl(c) && c !== 0x0a)
            continue;
        out += text[i];
    }
    return out;
}
/** Line breaks as LF, unsafe characters removed, surrounding whitespace trimmed. */
export function cleanText(raw) {
    return stripUnsafe(raw.replace(/\r\n?/g, '\n')).trim();
}
//# sourceMappingURL=plain-text.js.map